/**
 * Formats a number to French format with spaces as thousand separators.
 * @param num - The number to format.
 * @returns The formatted number as a string.
 */
export const formatNumberToFr = (num: number): string => {
  return num.toLocaleString("fr-FR");
};
